module.exports = __webpack_public_path__ + "img/civicwise.edf4f125.png";